import TopBenefits from './TopBenefits'

export default TopBenefits
